import { render } from "./Kv.vue?vue&type=template&id=6ae4e8aa"
import script from "./Kv.vue?vue&type=script&lang=js"
export * from "./Kv.vue?vue&type=script&lang=js"

import "./Kv.vue?vue&type=style&index=0&id=6ae4e8aa&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__